import React from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/app.css';


import Splash from './src/react-view/widgets/splash/splash.js';
import Root from './src/react-view/widgets/root/root.js';

class AppStore {
} 

class AppCore extends React.Component  {
	
	constructor(props) {
		super(props);
		
		console.log('App constructor called');
		this.exec_env = AppCore.EXEC_ENV;
		
		this.current_version = '0.20.67.2022.04.19';

		AppCore.theapp = this;

		this.basename = (AppCore.BASE_NAME ? AppCore.BASE_NAME : "my-widget");


		this.uuid = this.guid();

		this.varmap = Object.create(null);

		this.isReady = false;

		this.rootsessionuuid = null;

		this.device_wallet = null;
		this.device_wallet_promise = null;

		// client[s]
		this.registered_client_uuid = null;
		this.widget_client_version = null;
		this.widget_client_window_url = null;

		this.state = {
			loading: true,
		};
	}

	async onLoaded() {
		console.log('App.onLoaded called');

		try {

			// create mvc mywidget
			var MvcMyWidget = require('./src/model/mywidget/module.js').default;
			this.mvcmywidget = MvcMyWidget.getObject();
	
			if (!AppCore.mvcmywidget){
				// because App can be constructed multiple times
				AppCore.mvcmywidget = this.mvcmywidget;
			}

			await this.mvcmywidget.initAsync();

			// set client module
			var Client = require('../../js/src/web-client.js').default;
			var clientmodule = Client.getObject();

			if (this.exec_env === 'dev') {
				clientmodule.execution_env = 'dev';
			}

			await clientmodule.init();
			
			this.mvcmywidget.setClientModuleObject(clientmodule);




			// read query string parameters for start conditions
			var start = {};

			const url = window.location.href;

			var query = url.split('?')[1];

			if (query) {
				let queryparams = {};
			
				let vars = query.split('&');
				for (var i = 0; i < vars.length; i++) {
					let pair = vars[i].split('=');
					let key = decodeURIComponent(pair[0]);
					let value = decodeURIComponent(pair[1])
					
					queryparams[key] = value;
				}

				if (queryparams.b64params) {
					// params have been encoded
					let subquery = this.decodebase64(queryparams.b64params);
					let subvars = subquery.split('&');
					for (var i = 0; i < subvars.length; i++) {
						let pair = subvars[i].split('=');
						let key = decodeURIComponent(pair[0]);
						let value = decodeURIComponent(pair[1])
						
						queryparams[key] = value;
					}
				}
	
				start.fullurl = url;
				start.queryparams = queryparams;

				// start conditions
				start.url = await this.getCleanUrl();
				Object.assign(start, queryparams);
	
				this.setStartConditions( start, true); // true to sanitize parameters like returnurl, callbackurl
			}


			
			console.log('App.onLoaded setting loading to false');
			this.isReady = true;
			this.setState({loading: false});

			if (start.widget) {
				// start conditions were given through the parameters
				var route = start.widget;
				this.gotoRoute(route, start);
			}

			return true;
		}
		catch(e) {
			console.log('exception in App.onLoaded: ' + e);
		}

		this.setState({loading: false});
		return false;
	}

	// render
	render() {

		if (this.state.loading) {
			return (
				<div className="App">
					<Splash 
						app = {this}
						msg = 'loading app...'
					/>
				</div>
			);
		}

		return (
			<div className="App">
				<Root
					app = {this}
				/>
			</div>
		);
	}

	// accessible to childrens to use core api
	getMvcMyWidget() {
		if (this.mvcmywidget)
			return this.mvcmywidget;
		else{
			if (AppStore.mvcmywidget)
				this.mvcmywidget = AppStore.mvcmywidget;

			return AppStore.mvcmywidget;
		} 
	}

	async getRootSessionUUID() {
		if (this.rootsessionuuid)
			return this.rootsessionuuid;

		var mvcmywidget = this.getMvcMyWidget();

		this.rootsessionuuid = await mvcmywidget.createBlankSession();

		return this.rootsessionuuid;
	}

	async openSessionWallet(sessionuuid, schemeconfig) {
		let rootsessionuuid = await this.getRootSessionUUID();

		let mvcmywidget = this.getMvcMyWidget();

		let walletsessionuuid;

		if (schemeconfig) {
			let schemeuuid = schemeconfig.uuid;

			// check if scheme exists
			let scheme = await mvcmywidget.getSchemeInfo(rootsessionuuid, schemeuuid).catch(err => {});

			if (!scheme) {
				scheme = await mvcmywidget.importScheme(rootsessionuuid, schemeconfig);
			}

			// import session
			walletsessionuuid = await mvcmywidget.importSession(sessionuuid, schemeuuid);

			// get user name
			let user = await mvcmywidget.getUserInfo(sessionuuid).catch(err => {});

			if (!user)
				return walletsessionuuid;

			let username = user.name;

			// see if we can find a wallet
			let persistedwallet;
			let walletlist = await mvcmywidget.getWalletList(rootsessionuuid).catch(err => {});

			for (var i = 0; i < (walletlist ? walletlist.length : 0); i++) {
				var walletinfo = walletlist[i];
				if ( username && (walletinfo.name !== username)) {continue;}
	
				if (walletinfo && (walletinfo.schemeuuid === schemeuuid)) {
					persistedwallet = walletinfo;
					break;
				}
			}

			// then attach session to wallet
			if (persistedwallet) {
				await mvcmywidget.attachSessionToWallet(sessionuuid, persistedwallet.uuid)
				.catch(err => {
					console.log('error in App.openSessionWallet:' + err);
				});
			}
			else {
				// or create a wallet from session
				persistedwallet = await mvcmywidget.makeWalletFromSession(sessionuuid, schemeuuid)				
				.catch(err => {
					console.log('error in App.openSessionWallet:' + err);
				});
			}

			this._setDeviceWallet(persistedwallet);
		}
	
		return walletsessionuuid;
	}

	async _getDeviceWalletPromise() {
		var mvcmywidget = this.getMvcMyWidget();

		let rootsessionuuid = await this.getRootSessionUUID();

		var devicewllt = await mvcmywidget.readSettings('devicewallet');

		if (!devicewllt) {
			var devicewallet;
			var walletuuid;
			var walletname = 'devicewallet';
			// we generate a password
			let password = mvcmywidget.guid();

			// and create a wallet
			var localscheme = await mvcmywidget.getDefaultLocalSchemeInfo(rootsessionuuid);
			var localschemeuuid = localscheme.uuid;

			devicewallet = await mvcmywidget.makeWallet(rootsessionuuid, walletname, localschemeuuid, password)
			.catch(err => {
				console.log('error in Root._openDeviceWallet: ' + err);
			});

			if (!devicewallet)
				return Promise.reject('could not create wallet for device');

			walletuuid = devicewallet.uuid;

			// we save device wallet info in the settings
			devicewllt = {};

			devicewllt.walletuuid = walletuuid;
			devicewllt.password = password;
			
			await mvcmywidget.putSettings('devicewallet', devicewllt);
		}

		var islocked = await mvcmywidget.isWalletLocked(rootsessionuuid,  devicewllt.walletuuid);
		
		if (islocked) {
			await mvcmywidget.unlockWallet(rootsessionuuid, devicewllt.walletuuid, devicewllt.password);
		}
	

		if (devicewllt && devicewllt.walletuuid) 
			return mvcmywidget.getWalletInfo(rootsessionuuid, devicewllt.walletuuid);
	}

	async getDeviceWallet() {
		// need to avoid re-entrance, to prevent relocking the wallet
		if (this.device_wallet)
			return this.device_wallet; 

		if (this.device_wallet_promise)
			return this.device_wallet_promise;

		this.device_wallet_promise = this._getDeviceWalletPromise();

		return this.device_wallet_promise;
	}

	_setDeviceWallet(wallet) {
		// can be a remote wallet created through openSessionWallet
		this.device_wallet = wallet;
	}

	// scheme, currency and card
	async getCurrencyContext(context, settings_entry) {
		var mvcmywidget = this.getMvcMyWidget();
		var start_conditions = this.getVariable('start_conditions');

		if (!start_conditions)
			return Promise.reject('not start conditions to create currency context');

		let settings = await mvcmywidget.readSettings(settings_entry);

		var rootsessionuuid = await this.getRootSessionUUID();
		var devicewallet = await this.getDeviceWallet();
		var walletuuid = devicewallet.uuid;

		let widget_execution = this.getVariable(settings_entry);

		if (!widget_execution) {
			widget_execution = {};

			this.setVariable(settings_entry, widget_execution);
		}


		let currentscheme = context.currentscheme;
		let currentcard = context.currentcard;
		let currency = context.currency;

		// check if scheme and currency are already created
		let schemeuuid;
		let currencyuuid;
		let carduuid;

		let _scheme;
		let _card;
		let _currency;

		//
		// scheme
		//
		if (!currentscheme) {
			schemeuuid = (settings ? settings.schemeuuid : null);
	
			if (schemeuuid) {
				_scheme = await mvcmywidget.getSchemeInfo(rootsessionuuid, schemeuuid)
				.catch(err => {
					console.log('error in App.getCurrencyContext: ' + err);
				});

				if (_scheme) {
					if (start_conditions.web3_provider_url) {
						// check _scheme still matches with start_conditions.web3_provider_url;
						let _scheme_web3_provider_url = _scheme.network.ethnodeserver.web3_provider_url;
						let _are_equals = await mvcmywidget.compareUrl(rootsessionuuid, start_conditions.web3_provider_url, _scheme_web3_provider_url);

						if (!_are_equals) {
							// reset settings
							await mvcmywidget.putSettings(settings_entry, {});
							
							// recompute context from new start_conditions
							return this.getCurrencyContext(context, settings_entry);
						}

						// TODO: should check also other parameters like default_gas_limit, default_gas_price,...
					}
				}
				else {
					schemeuuid = null;
				}

			}
	
			context.currentscheme = _scheme;
		}
		else {
			_scheme = currentscheme;
			schemeuuid = currentscheme.uuid;
		}


		if (!_scheme) {
			let web3url = start_conditions.web3_provider_url;
			let options = {};

			options.chainid = (start_conditions.chainid ? start_conditions.chainid : null);
			options.networkid = (start_conditions.networkid ? start_conditions.networkid : null);

			options.default_gas_limit = (start_conditions.default_gas_limit ? start_conditions.default_gas_limit : null);
			options.default_gas_price = (start_conditions.default_gas_price ? start_conditions.default_gas_price : null);
			options.avg_transaction_fee = (start_conditions.avg_transaction_fee ? start_conditions.avg_transaction_fee : null);
			options.transaction_units_min = (start_conditions.transaction_units_min ? start_conditions.transaction_units_min : null);

			options.rest_server_url = (start_conditions.rest_server_url ? start_conditions.rest_server_url : null); 
			options.rest_server_api_path = (start_conditions.rest_server_api_path ? start_conditions.rest_server_api_path : null);



			// look if we have a local scheme corresponding to web3 url
			_scheme = await mvcmywidget.findLocalSchemeInfoFromWeb3Url(rootsessionuuid, web3url, options)
			.catch(err => {
				console.log('error in App.getCurrencyContext: ' + err);
			});


			if (!_scheme) {
				// create scheme now
				if (!widget_execution.scheme_creation_promise) {
					console.log('creating a promise to build a scheme');

					var _scheme_label = 'scheme for client ' + start_conditions.client_id;
					var _schm;
	
					widget_execution.scheme_creation_promise = mvcmywidget.buildSchemeFromWeb3Url(rootsessionuuid, walletuuid, web3url, options)
					.then((schm) => {
						_schm = schm;

						// set label
						return mvcmywidget.setSchemeLabel(rootsessionuuid, _schm.uuid, _scheme_label);
					})
					.then(() => {
						return _schm;
					});
				}

				_scheme = await widget_execution.scheme_creation_promise
				.catch(err => {
					console.log('error in App.getCurrencyContext: ' + err);
				});
			}

			if (!_scheme)
				return Promise.reject('Problem creating scheme');

			schemeuuid = _scheme.uuid;

			settings = (settings ? settings : {});

			settings.schemeuuid = schemeuuid;

			await mvcmywidget.putSettings(settings_entry, settings);

			context.currentscheme = _scheme;
		}


		//
		// currency (if already created)
		//
		let _tokenaddress = start_conditions.tokenaddress;

		if (!currency) {
			currencyuuid = (settings ? settings.currencyuuid : null);

			if (currencyuuid) {
				_currency = await mvcmywidget.getCurrencyFromUUID(rootsessionuuid, currencyuuid)
				.catch(err => {
					console.log('error in App.getCurrencyContext: ' + err);
				});

				if (_currency) {
					if (!_currency.name || !_currency.symbol || !_currency.decimals) {
						await mvcmywidget.synchronizeCurrency(rootsessionuuid, walletuuid, _currency)
						.catch(err => {
							console.log('error in App.getCurrencyContext: ' + err);
						});
					}

					if (_tokenaddress) {
						// check _currency still matches with start_conditions.tokenaddress
						let _are_equals = await mvcmywidget.areAddressesEqual(rootsessionuuid, _tokenaddress, _currency.address);

						if (!_are_equals) {
							// reset settings
							await mvcmywidget.putSettings(settings_entry, {});
							
							// recompute context from new start_conditions
							return this.getCurrencyContext(context, settings_entry);
						}
					}
				}
				else {
					currencyuuid = null;
				}




			}

			if (!_currency && _tokenaddress) {
				// look if we have a currency with this address for this scheme
				let _existing_currencies = await mvcmywidget.getCurrenciesFromAddress(rootsessionuuid, walletuuid, schemeuuid, _tokenaddress)
				.catch(err => {
					console.log('error in App.getCurrencyContext: ' + err);
				});

				if (_existing_currencies && (_existing_currencies.length > 0)) {
					_currency = _existing_currencies[0]; // take first (and hopefully only one)
					currencyuuid = _currency.uuid;

					settings = (settings ? settings : {});

					settings.currencyuuid = currencyuuid;
		
					await mvcmywidget.putSettings(settings_entry, settings);
				}
			}

			context.currency = _currency;
		}
		else {
			_currency = currency;
		}



		//
		// card
		//
		let _cardaddress = start_conditions.cardaddress;

		if (!currentcard) {
			carduuid = (settings ? settings.carduuid : null);

			if (carduuid) {
				_card = await mvcmywidget.getWalletCard(rootsessionuuid, walletuuid, carduuid)
				.catch(err => {
					console.log('error in App.getCurrencyContext: ' + err);
				});

				if (_card && _cardaddress) {
					// check this card matches requested card address
					let _found_address = _card.address;
					let _are_equals = await mvcmywidget.areAddressesEqual(rootsessionuuid, _found_address, _cardaddress);

					if (!_are_equals) {
						_card = null; // reject this card
					}
				}
			}

			context.currentcard = _card;
		}
		else {
			_card = currentcard;
			carduuid = currentcard.uuid;
		}

		if (!_card) {
			if (currencyuuid) {
				if (_cardaddress) {
					// check if we can find a card with this address
					_card = await mvcmywidget.getCurrencyCardWithAddress(rootsessionuuid, walletuuid, currencyuuid, _cardaddress)
					.catch(err => {
						console.log('error in App.getCurrencyContext: ' + err);
					});
				}
	
	
				if (!_card && (start_conditions.pick_main_currency_card !== false) && (start_conditions.pick_main_currency_card !== 'false')) {
					// look if we have a corresponding main currency card
					_card = await mvcmywidget.getCurrencyCard(rootsessionuuid, walletuuid, currencyuuid)
					.catch(err => {
						console.log('error in App.getCurrencyContext: ' + err);
					});
				}

				if (_card) {
					carduuid = _card.uuid;

					settings = (settings ? settings : {});
	
					settings.carduuid = carduuid;
	
					await mvcmywidget.putSettings(settings_entry, settings);
	
					context.currentcard = _card;		
				}
			}

			if (!_card) {
				// create card now
				const private_key = await mvcmywidget.generatePrivateKey(rootsessionuuid);

				if (!widget_execution.card_creation_promise) {
					console.log('creating a promise to create a card');
					widget_execution.card_creation_promise = mvcmywidget.createWalletCard(rootsessionuuid, walletuuid, schemeuuid, private_key);
				}


				_card = await widget_execution.card_creation_promise
				.catch(err => {
					console.log('error in App.getCurrencyContext: ' + err);
				});

				if (_card) {
					carduuid = _card.uuid;

					settings = (settings ? settings : {});
	
					settings.carduuid = carduuid;
	
					await mvcmywidget.putSettings(settings_entry, settings);
	
					context.currentcard = _card;		
				}

			}
		}

		if (!_card)
			return Promise.reject('Problem creating card');

		
		//
		// currency final
		//
		
		if (!_currency && _tokenaddress) {
			// create currency now 
			if (!widget_execution.currency_creation_promise) {
				console.log('creating a promise to import a currency from token address');
				let options = {};

				if (typeof start_conditions.cantopup != 'undefined')	
					options.cantopup = start_conditions.cantopup;
				if (typeof start_conditions.cantxfree != 'undefined')	
					options.cantxfree = start_conditions.cantxfree;

				var _currency_description = 'currency for client ' + start_conditions.client_id;
				var _ccy;

				widget_execution.currency_creation_promise = mvcmywidget.importCurrencyFromTokenAddress(rootsessionuuid, walletuuid, carduuid, _tokenaddress, options)
				.then((ccy) => {
					_ccy = ccy;

					// set description
					return mvcmywidget.setCurrencyDescription(rootsessionuuid, walletuuid, _ccy.uuid, _currency_description);				
				})
				.then(() => {
					return _ccy;
				});
			}

			_currency = await widget_execution.currency_creation_promise
			.catch(err => {
				console.log('error in App.getCurrencyContext: ' + err);
			});

			if (_currency) {
				currencyuuid = _currency.uuid;

				settings = (settings ? settings : {});

				settings.currencyuuid = currencyuuid;
	
				await mvcmywidget.putSettings(settings_entry, settings);

				context.currency = _currency;

				// requires a page refresh
				context._refresh_page = true;
			}
			else {
				console.log('token address is invalid ' + _tokenaddress);
			}
		}

		if (_currency) {
			currencyuuid = _currency.uuid;
			console.log('found currency ' + currencyuuid);

			context.currency = _currency;
		}

		// send event
		let _currencyuuid = (context.currency ?  context.currency.uuid : null);

		this.postParent({action: 'receive_event', event_name: 'on_currency_context_ready', currencyuuid: _currencyuuid});

		return context;
	}

	checkMobile() {
		let check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
		return check;
	}

	// start conditions
	getStartConditions() {
		return this.getVariable('start_conditions');
	}

	setStartConditions(json, sanitize) {

		if (sanitize) {
			if (json.web3_provider_url) json.web3_provider_url = this.decodebase64(json.web3_provider_url);
			if (json.explorer_url) json.explorer_url = this.decodebase64(json.explorer_url);

			if (json.remote_wallet_url) json.remote_wallet_url = this.decodebase64(json.remote_wallet_url);
			if (json.returnurl) json.returnurl = this.decodebase64(json.returnurl);
			if (json.callbackurl) json.callbackurl = this.decodebase64(json.callbackurl);

			if (json.rest_server_url) json.rest_server_url = this.decodebase64(json.rest_server_url);

			if (json.remote_wallet_params_string) {
				json.remote_wallet_params_string = this.decodebase64(json.remote_wallet_params_string);

				try {
					json.remote_wallet_params = JSON.parse(json.remote_wallet_params_string);
				}
				catch(e) {
				}
			}

			if (json.local_wallet_params_string) {
				json.local_wallet_params_string = this.decodebase64(json.local_wallet_params_string);

				try {
					json.local_wallet_params = JSON.parse(json.local_wallet_params_string);
				}
				catch(e) {
				}
			}
		}

		this.setVariable('start_conditions', json);

		// fire event
		this.postParent({action: 'receive_event', event_name: 'on_start_conditions_set', start_conditions: json});
	}

	isMutable() {
		let start_conditions = this.getStartConditions();
		
		if (!start_conditions)
			return false;

		if ((start_conditions.mutable === true) || (start_conditions.mutable === 'true'))
			return true;
		else
		 return false;
	}


 	// variables
	getVariable(key) {
		return this.varmap[key];
	}
	
	setVariable(key, value) {
		console.log('App.setVariable ' + key + ' to ' + (value ? ' value' : ' null'));
		this.varmap[key] = value;
	}
	
	// communication with top window
	postParent(data) {
		if (window.parent) {
			// add our uuid
			data.app_uuid = this.uuid;

			var datastring = (data ? JSON.stringify(data) : '{}');
			window.parent.postMessage(datastring, '*');
		}		
	}

	async answerRequest(request, answer) {
		if (!request || !request.request_uuid)
			return;

		var data = {action: 'receive_answer', request_uuid: request.request_uuid, answer: (answer ? answer : {})};

		return this.postParent(data);
	}

	async sendParent(data) {
		// we need to be sure someone will answer
		// to avoid hanging promises
		if (!this.registered_client_uuid)
			return;

		return new Promise((resolve, reject) => {
			data.request_uuid = this.guid();
			data.registered_widget_client_uuid = this.registered_client_uuid;
			this.postParent(data);

			var receive_answer = (ev) => {
				let answer = ev.detail;
				resolve(answer);

				window.removeEventListener('request_' + data.request_uuid, receive_answer);
			};
			
			window.addEventListener('request_' + data.request_uuid, receive_answer);
		})
		.catch(err => {
			console.log('exception in App.sendParent: ' + err);
		});

	}

	receiveAnswer(request_uuid, answer) {
		const event = new CustomEvent('request_' + request_uuid, {detail: answer});

		window.dispatchEvent(event);
	}

	async handleMessage(ev) {
		try {
			let datastring = ev.data;

			if (!datastring || (typeof datastring !== 'string' && (datastring instanceof String !== true)) )
			return;

			if ((datastring.length < 2) || (datastring.startsWith('{') !== true))
			return;

			let mvcmywidget = this.getMvcMyWidget();
			let json = JSON.parse(datastring);

			// actions at app's level
			switch(json.action) {

				//
				// communication from App to widget client 
				//

				case 'receive_answer': {
						let request_uuid = json.request_uuid;
						let answer = json.answer;

						this.receiveAnswer(request_uuid, answer);
					}
					break;

				//
				// communication from widget client to App
				//

				case 'setStartConditions':
				case 'set_start_conditions': {
						let current_start_conditions = this.getStartConditions();

						if (current_start_conditions && (current_start_conditions.mutable !== true))
							return; // can not reset conditions for an immutable widget
						
						json.url = await this.getCleanUrl();
						this.setStartConditions( json);

						var route = json.widget;
						this.gotoRoute(route, json);
					}
					break;
				case 'setStartConditionsParameter':
				case 'set_start_conditions_parameter': {
						let current_start_conditions = this.getStartConditions();

						if (!current_start_conditions)
							return;

						if (this.isMutable() !== true)
							return; // can not reset conditions for an immutable widget
						
						if (current_start_conditions && json.key) {
							current_start_conditions[json.key] = json.value;
						}
					}
					break;
				case 'openSessionWallet':
				case 'open_session_wallet': {
						let sessionuuid = await this.openSessionWallet(json.sessionuuid, json.schemeconfig);

						this.answerRequest(json, {sessionuuid});
					}
					break;

				case 'setExecutionEnvironment':
				case 'set_execution_environment':
					mvcmywidget.setExecutionEnvironment(json.env);
					break;

				case 'loadL10nStrings':
				case 'load_l10n_strings': {
						let current_start_conditions = this.getStartConditions();
						// contrary to setStartConditionsParameter can be
						// even if widget is immutable
						current_start_conditions['strings'] = json.strings;
					}
					break;
				case 'refreshWidget':
				case 'refresh_widget':
					this.refreshPage();
					break;

				// App level API
				// asnwering client's requests
				case 'registerClient':
				case 'register_client': {
						await this.onRegisterClient(json.widget_client_uuid);
						this.answerRequest(json, {widget_client_uuid: this.registered_client_uuid});
					}
					break;
			
				case 'getVersionInfo':
				case 'get_version_info':
					this.answerRequest(json, {version: this.current_version});
					break;

				case 'getAppUUID':
					this.answerRequest(json, {app_uuid: this.uuid});
					break;

				case 'isMutable': {
						let mutable = this.isMutable();
						this.answerRequest(json, {mutable});
					}
					break;

				case 'generateUUID': {
						let uuid = this.guid();
						this.answerRequest(json, {uuid});
					}
					break;

				case 'isOnMobile': {
						let check = this.checkMobile();
						this.answerRequest(json, {on_mobile: check});
					}
					break;
		
				case 'switchTo':
				case 'switch_to': {
						await this.switchTo(json.widget);
						let start_conditions = this.getStartConditions();
						this.answerRequest(json, {widget: start_conditions.widget});
					}
					break;
		
				case 'getWidgetSize': {
						let size = this.getWidgetSize();
						this.answerRequest(json, {size});
					}
					break;

				case 'getAppInfo': {
						let version = this.current_version;
						let app_uuid = this.uuid;
						let mutable = this.isMutable();
						let on_mobile = this.checkMobile();
						let widget_size = this.getWidgetSize();

						let current_start_conditions = this.getStartConditions();
						let start_url = (current_start_conditions ? current_start_conditions.url : null);
						let start_fullurl = (current_start_conditions ? current_start_conditions.fullurl : null);
						let start_widget_uuid = (current_start_conditions ? current_start_conditions.widget_uuid : null);

						this.answerRequest(json, {version, start_url, start_fullurl, start_widget_uuid, app_uuid, mutable, on_mobile, widget_size});
					}
					break;

			
			
				default:
					break;
			}

			// forward message to subscribed widgets
			mvcmywidget.signalEvent('on_handle_message', json);


		}
		catch(e) {
			console.log('exception in App.handleMessage: ' + e);
		}
	}

	async onRegisterClient(widget_client_uuid) {
		if (!this.registered_client_uuid) {
			// first-come, first-served
			this.registered_client_uuid = widget_client_uuid;
		}

		// we ask client's version
		var answer_struct = await this.sendParent({action: 'get_version_info'}).catch(err => {});

		this.widget_client_version = (answer_struct ? answer_struct.version : null);

		// we ask for parent's current url (security protected for cross-sites) now
		var answer_struct = await this.sendParent({action: 'get_current_url'}).catch(err => {});

		this.widget_client_window_url = (answer_struct ? answer_struct.url : null);
	}

	getWidgetClientVersion() {
		return this.widget_client_version;
	}

	getWidgetClientWindowUrl() {
		return this.widget_client_window_url;
	}

	// state & refresh
	async _setState(json) {
		return new Promise((resolve, reject) => {
			this.setState(json, (err, res) => {
				if (err) reject(err); else resolve(res);
			});
		})
	}

	async refreshPage() {
		console.log('App.refreshPage called');
		
		let lastrefresh = Date.now();
		
		await this._setState({lastrefresh: lastrefresh});
		
		let mvcmywidget = this.mvcmywidget;
		
		if (mvcmywidget)
		mvcmywidget.signalEvent('on_refreshPage');

		return true;
	}

	// navigation
	async switchTo(widgetname) {
		// TODO: implement a switch to avoid a complete reload of iframe
		
		// change startconditions
		var start_conditions = this.getStartConditions();

		start_conditions.widget = widgetname;

		return this.gotoRoute(widgetname);
	}

	async gotoRoute(route, params = []) {
		
		var _root = this.getVariable('Root');
		
		if (_root) {
			await _root._gotoRoute(route, params);
		}
		else {
			console.log('root component was not ready to process route: ' + route);
			// we will let root (or other components) check navigation state to post-process this route
		}
		
		await this.refreshPage();
	}

	async gotoUrl(url, options) {
		if (options && (options.pop_up === true)) {
			var name = this.t("Primus Wallet");
			var _options = 'height=640,width=640';
	
			var win = window.open(url, name, _options);
	
			console.log('popup window ' + (win ? 'opened': 'NOT opened'));
		}
		else {
			// post message to parent
			var data = {action: 'goto_url', url};
			await this.postParent(data);
			
			if (window.parent) {
				// do the jump anyway in case we don't have a WidgetClient listening in the parent window
				// (e.g. fixed embedded widget)
				window.parent.location = url;
			}
		}		
	}

	async getCleanUrl() {
		var cleanurl = window.location.href;

		if (cleanurl.indexOf('#') != -1) {
			// strip anchors
			cleanurl = cleanurl.slice(0, cleanurl.indexOf('#'));
		}

		if (cleanurl.indexOf('?') != -1) {
			// strip parameters
			cleanurl = cleanurl.slice(0, cleanurl.indexOf('?'));
		}

		return cleanurl;
	}

	async getRemoteWalletUrl(device) {
		let start_conditions = this.getVariable('start_conditions');

		var uri;

		let ismobile = (device && (device === 'mobile') ? true : this.checkMobile());

		if (start_conditions.remote_wallet_url) {
			uri = start_conditions.remote_wallet_url;

			if (ismobile)  {
				// is url overloaded for mobile
				uri = (start_conditions.mobile_wallet_url ? start_conditions.mobile_wallet_url : uri);
			}
			else {
				// is url overloaded for desktop
				uri = (start_conditions.desktop_wallet_url ? start_conditions.desktop_wallet_url : uri);
			}
		}
		else {
			 uri = await this.getLocalWalletUrl();
		}
		
		return uri;
	}

	async getLocalWalletUrl() {
		let start_conditions = this.getVariable('start_conditions');

		var uri;

		const URL = require("url");

		let { protocol, host, hostname, pathname, query } = URL.parse(start_conditions.url, true);
		
		 uri = protocol + '//' + host + '/my-wallet/';
	
		return uri;
	}

	getWidgetSize() {
		let width = window.innerWidth;
		let height = window.innerHeight;

		let size = 'small';

		if ( (width < 600) || (height < 400) )
			size = 'small';
		else if ( (width < 1200) || (height < 800) )
			size = 'medium';
		else
			size = 'large';

		return size;
	}

	async getSubDomain() {
		var fullurl = window.location.href;

		var hostname = window.location.hostname;

		if (hostname == 'localhost')
			return;

		var ipformat = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
 		if(hostname.match(ipformat))
			return;

		var subdomain = hostname.split('.')[0]; // only first if multiple (e.g. https://webapp.www.example.com)

		return subdomain;
	}

	// alert
	async alert(message) {
		return window.alert(message);
	}
	
	async error(message) {
		if (this.exec_env === 'dev')
		return this.alert(message);
	}

	async confirm(question) {
		return window.confirm(question)
	}

	// utils
	t(str) {
		// caller translations
		var start_conditions = this.getVariable('start_conditions');

		if (start_conditions && start_conditions.strings && Array.isArray(start_conditions.strings)) {
			var strings = start_conditions.strings;

			for (var i = 0; i < strings.length; i++) {
				if (strings[i].en == str)
					return strings[i].l10n;
			}
		}

		// let's try at the framework level
		var mvcmywidget = this.mvcmywidget;
		
		return mvcmywidget.t(str);
	}

	guid() {
		if (this.mvcmodule)
			return this.mvcmodule.guid();
		
		function s4() {
			return Math.floor((1 + Math.random()) * 0x10000)
				.toString(16)
				.substring(1);
		}
		
		return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
			s4() + '-' + s4() + s4() + s4();
	}

	_getBufferClass() {
		var _Buffer;
		try {
			if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
				_Buffer = window.Buffer;
			} else {
				_Buffer = require('buffer').Buffer;
			}
		} catch (e) {
		}
		
		return _Buffer;
	}

	encodebase64(str) {
		var _Buffer = this._getBufferClass();
		return _Buffer.from(str).toString('base64');
	}

	decodebase64(b64) {
		var _Buffer = this._getBufferClass();
		return _Buffer.from(b64, 'base64').toString('utf8');;
	}

	// App API
	async getCurrencyAmount(currencyuuid, amount) {
		var mvcmywidget = this.getMvcMyWidget();

		let rootsessionuuid = await this.getRootSessionUUID();
		let tokenamount = await mvcmywidget.getCurrencyAmount(rootsessionuuid, currencyuuid, amount);
		let tokenamount_int = await tokenamount.toInteger();

		return tokenamount_int;
	}

	// static methods
	static getAppObject() {
		if (AppCore.theapp)
			return AppCore.theapp;

			AppCore.theapp = new AppCore();

		return AppCore.theapp;
	}

} 

export default AppCore;